<div class="w-[100%] flex justify-end pr-[31px] mb-[6px] mt-[72px]">
  <div class="flex justify-start mr-[10px]">
    <button (click)="handleClose()" class="close-button mr-[7px]">Back</button>
    <button (click)="openDialog()" class="print-button">Print</button>
  </div>
</div>

<div
  class="mt-[0px] m-[30px] pt-[43px] p-[25px] rounded-lg shadow-lg wrapper mb-[60px]"
>
  <!-- Header -->
  <div class="flex justify-between">
    <div class="flex flex-col items-end">
      <h3 class="!m-0 title-value">{{ projectData?.projectData?.name }}</h3>
    </div>
    <div>
      <img
        src="assets/images/logo.png"
        alt="logo"
        class="h-[78px] w-[78px] rounded-[7px]"
      />
    </div>
  </div>

  <!-- Project Type and Brief -->
  <div class="flex justify-start gap-[50px] w-[100%] mt-[34px] min-h-[228px]">
    <div class="w-[30%] p-[30px] project-attributes-container">
      <ng-container *ngFor="let projectType of projectTypeData; let i = index">
        <p class="project-attribute">
          {{ i === 0 ? "Project Type" : "Project Sub Type" }}
        </p>
        <p class="project-attribute-value">
          {{ projectType }}
        </p>
      </ng-container>
    </div>
    <div class="w-[70%] flex flex-col justify-center">
      <p class="brief">Brief</p>
      <p
        class="brief-value"
        [innerHTML]="getSanitizedHtml(projectData?.projectData?.description)"
      ></p>
    </div>
  </div>

  <!-- Location and Site Conditions -->
  <div class="flex justify-start gap-[50px] w-[100%] mt-[34px] min-h-[228px]">
    <div class="w-[29%] p-[30px] pt-[0px]">
      <p class="site-condition">Location and Site Conditions</p>
      <div class="mt-[12px]">
        <p class="project-attribute">Country</p>
        <p class="project-attribute-value">{{ projectCountryData?.name }}</p>
      </div>
      <div class="mt-[12px]">
        <p class="project-attribute">City</p>
        <p class="project-attribute-value">
          {{ projectData?.projectData?.city }}
        </p>
      </div>
      <div class="mt-[12px]">
        <p class="project-attribute">Zip Code</p>
        <p class="project-attribute-value">
          {{ projectData?.projectData?.zip }}
        </p>
      </div>
      <div class="mt-[12px]">
        <p class="project-attribute">Street</p>
        <p class="project-attribute-value">
          {{ projectData?.projectData?.street }}
        </p>
      </div>
      <div class="mt-[12px]">
        <p class="project-attribute">Latitude</p>
        <p class="project-attribute-value">
          {{ projectData?.projectData?.latitude }}
        </p>
      </div>
      <div>
        <p class="project-attribute">Longitude</p>
        <p class="project-attribute-value !mb-[0px]">
          {{ projectData?.projectData?.longitude }}
        </p>
      </div>
    </div>

    <div class="flex-1 flex items-start">
      <div class="flex flex-col">
        <p class="brief">Site Conditions</p>
        <p
          class="brief-value"
          [innerHTML]="
            getSanitizedHtml(projectData?.projectData?.site_conditions)
          "
        ></p>
      </div>
    </div>
    <div class="flex-1 flex items-center">
      <iframe
        width="100%"
        height="244px"
        style="border: 0"
        loading="lazy"
        [src]="mapLink"
      ></iframe>
    </div>
  </div>

  <!-- Images and Documents -->
  <div class="flex justify-start gap-[50px] w-[100%] mt-[20px]">
    <div class="w-[29%]"></div>
    <div class="flex-1 flex items-center">
      <div>
        <p class="site-images">Site images</p>
        <app-gallery
          [uploadedFiles]="locationAttachments"
          [isEdit]="false"
        ></app-gallery>
        <p class="site-images !mt-[18px]">Documents</p>
        <app-gallery
          [uploadedFiles]="siteConditionAttachments"
          [isEdit]="false"
        ></app-gallery>
      </div>
    </div>
  </div>

  <!-- Key Deliverables -->
  <div class="flex justify-start gap-[50px] w-[100%] mt-[20px] min-h-[228px]">
    <div class="w-[29%] p-[30px] project-attributes-container">
      <div class="key-deliverable">Key Deliverables</div>
    </div>
    <div class="flex-1 flex items-start mt-[30px]">
      <ul class="!pl-0">
        <div *ngFor="let goal of projectData?.projectGoalsData" class="flex">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 10 10"
            fill="none"
          >
            <path
              d="M4.61498 8.86234C4.58845 8.86234 4.56221 8.85685 4.53791 8.84621C4.51361 8.83558 4.49177 8.82003 4.47377 8.80055L0.666326 4.68199C0.640945 4.65454 0.624119 4.62027 0.617907 4.5834C0.611695 4.54653 0.616367 4.50865 0.631351 4.47439C0.646336 4.44013 0.670982 4.41099 0.702274 4.39052C0.733566 4.37005 0.770146 4.35915 0.807538 4.35915H2.64023C2.66775 4.35915 2.69494 4.36506 2.71998 4.37647C2.74502 4.38787 2.76732 4.40452 2.78538 4.42528L4.05785 5.88921C4.19536 5.59524 4.46158 5.10578 4.92873 4.50936C5.61935 3.62763 6.90392 2.33088 9.10169 1.16026C9.14417 1.13764 9.19359 1.13177 9.24018 1.14381C9.28678 1.15585 9.32717 1.18492 9.35338 1.22528C9.37958 1.26565 9.3897 1.31437 9.38174 1.36184C9.37377 1.4093 9.3483 1.45205 9.31035 1.48165C9.30196 1.4882 8.45458 2.15551 7.47935 3.3778C6.58181 4.50261 5.38869 6.34184 4.8016 8.71626C4.79128 8.75798 4.76729 8.79504 4.73346 8.82153C4.69963 8.84802 4.65789 8.86241 4.61492 8.86242L4.61498 8.86234Z"
              fill="#1A4971"
            />
          </svg>
          <div class="flex">
            <span class="h-[22px] mr-[10px]">{{ goal?.name }}</span>
          </div>
        </div>
      </ul>
    </div>
  </div>

  <!-- Budget -->
  <div class="flex justify-start gap-[50px] w-[100%] min-h-[228px]">
    <div class="w-[29%] p-[30px]">
      <div class="key-deliverable mb-[6px]">Budget</div>
      <div>
        <!-- TODO: -->
        <p class="project-attribute">Grade</p>
        <p class="project-attribute-value">{{ projectGradeData?.name }}</p>
      </div>
    </div>

    <div class="flex-1 flex flex-col items-start justify-center w-[100%]">
      <div class="w-[90%]">
        <div class="flex justify-between flex-col">
          <div class="flex justify-between items-center">
            <div>
              <p class="milestone-header">Total Allocated</p>
              <!-- TODO: this needs to be dynamic -->
              <p class="milestone-value !mb-[10px]">
                ${{ projectData?.projectBudgetData[0]?.amount }}
              </p>
            </div>
            <div class="w-[515px] flex justify-start">
              <div class="mt-[34px] mb-[34px]">
                <p class="milestone-header">Amount In Words</p>
                <p class="milestone-value !mb-[10px]">
                  <ng-container
                    *ngIf="projectData?.projectBudgetData[0]?.amount"
                  >
                    {{
                      numberToWords(projectData?.projectBudgetData[0]?.amount)
                        | titlecase
                    }}
                  </ng-container>
                </p>
              </div>
            </div>
          </div>

          <div
            *ngIf="
              projectData?.projectBudgetData[0]?.risk_and_contengency_amount
            "
            class="flex justify-between items-center"
          >
            <div>
              <p class="milestone-header">Risk & Contingency</p>
              <p class="milestone-value !mb-[10px]">
                ${{
                  projectData?.projectBudgetData[0]?.risk_and_contengency_amount
                }}
              </p>
            </div>
            <div class="w-[515px] flex justify-start">
              <div class="mt-[34px] mb-[34px]">
                <p class="milestone-header">Amount In Words</p>
                <p class="milestone-value !mb-[10px]">
                  <ng-container
                    *ngIf="
                      projectData?.projectBudgetData[0]
                        ?.risk_and_contengency_amount
                    "
                  >
                    {{
                      numberToWords(
                        projectData?.projectBudgetData[0]
                          ?.risk_and_contengency_amount
                      ) | titlecase
                    }}
                  </ng-container>
                </p>
              </div>
            </div>
          </div>

          <div
            *ngIf="projectData?.projectBudgetData[0]?.gmp_amount"
            class="flex justify-between items-center"
          >
            <div>
              <p class="milestone-header">GMP Amount</p>
              <p class="milestone-value !mb-[10px]">
                ${{ projectData?.projectBudgetData[0]?.gmp_amount }}
              </p>
            </div>
            <div class="w-[515px] flex justify-start">
              <div class="mt-[34px] mb-[34px]">
                <p class="milestone-header">Amount In Words</p>
                <p class="milestone-value !mb-[10px]">
                  {{
                    numberToWords(projectData?.projectBudgetData[0]?.gmp_amount)
                      | titlecase
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Milestones -->
  <div class="flex justify-start gap-[50px] w-[100%] min-h-[228px]">
    <div class="w-[29%] p-[30px] project-attributes-container">
      <div class="key-deliverable mb-[6px]">Milestones</div>
      <div>
        <p class="project-attribute">Start Date</p>
        <p class="project-attribute-value">
          {{ projectData?.projectData?.start_date | date : "yyyy-MM-dd" }}
        </p>
      </div>
      <div>
        <p class="project-attribute">End Date</p>
        <p class="project-attribute-value !mb-[0px]">
          {{ projectData?.projectData?.end_date | date : "yyyy-MM-dd" }}
        </p>
      </div>
    </div>

    <div
      class="flex-1 flex flex-col items-start mt-[30px] justify-start w-[100%]"
    >
      <div class="w-[90%]">
        <div class="flex justify-between">
          <div>
            <p class="milestone-header">Description</p>
          </div>
          <div>
            <p class="milestone-header">From</p>
          </div>
          <div class="pr-[50px]">
            <p class="milestone-header">To</p>
          </div>
        </div>
      </div>

      <div
        *ngFor="let milestone of projectData?.projectMileStonesData"
        class="w-[90%]"
      >
        <div class="flex justify-between">
          <div>
            <p class="milestone-value !mb-[10px]">{{ milestone?.name }}</p>
          </div>
          <div>
            <p class="milestone-value !mb-[10px]">
              {{ milestone?.start_date }}
            </p>
          </div>
          <div>
            <p class="milestone-value !mb-[10px] flex justify-start">
              {{ milestone?.end_date }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Stakeholders -->
  <div class="flex justify-start gap-[50px] w-[100%] min-h-[228px]">
    <div class="w-[29%] p-[30px]">
      <div class="key-deliverable">Stakeholders</div>
    </div>
    <div class="flex-1 flex flex-col items-start justify-start mt-[30px]">
      <div *ngFor="let stakeholder of projectData?.projectStakeHoldersData">
        <p class="project-attribute1">{{ stakeholder?.stake_holder }}</p>
      </div>
    </div>
  </div>
</div>

<!-- Print Dialog Template -->
<ng-template #dialogTemplate class="w-[100%]">
  <h2 mat-dialog-title>Print Preview</h2>
  <mat-dialog-content>
    <div
      id="projectBriefView"
      class="mt-[0px] m-[30px] pt-[43px] p-[25px] rounded-lg shadow-lg wrapper"
    >
      <div class="flex justify-between">
        <div class="flex flex-col items-end">
          <h3 class="!m-0 title-value">{{ projectData?.projectData?.name }}</h3>
          <div class="title">Project Title</div>
        </div>
        <div>
          <img
            src="assets/images/logo.png"
            alt="logo"
            class="h-[78px] w-[78px] rounded-[7px]"
          />
        </div>
      </div>
      <div
        class="flex justify-start gap-[50px] w-[100%] mt-[34px] min-h-[228px]"
      >
        <div class="w-[30%] p-[30px] project-attributes-container">
          <ng-container
            *ngFor="let projectType of projectTypeData; let i = index"
          >
            <p class="project-attribute">
              {{ i === 0 ? "Project Type" : "Project Sub Type" }}
            </p>
            <p class="project-attribute-value">
              {{ projectType }}
            </p>
          </ng-container>
          <p class="project-attribute">Grade</p>
          <p class="project-attribute-value">{{ projectGradeData?.name }}</p>
          <p class="project-attribute">Start Date</p>
          <p class="project-attribute-value">
            {{ projectData?.projectData?.start_date | date : "yyyy-MM-dd" }}
          </p>
          <p class="project-attribute">End Date</p>
          <p class="project-attribute-value !mb-[0px]">
            {{ projectData?.projectData?.end_date | date : "yyyy-MM-dd" }}
          </p>
        </div>

        <div class="w-[70%] flex flex-col justify-center">
          <p class="brief">Brief</p>
          <p
            class="brief-value"
            [innerHTML]="
              getSanitizedHtml(projectData?.projectData?.description)
            "
          ></p>
        </div>
      </div>

      <div class="flex justify-start gap-[50px] w-[100%] mt-[20px]">
        <div class="w-[29%]"></div>

        <div class="flex-1 flex items-center">
          <div class="">
            <div class="flex gap-[12px] mt-[9px] flex-wrap"></div>
          </div>
        </div>
      </div>

      <div
        class="flex justify-start gap-[50px] w-[100%] mt-[20px] min-h-[228px]"
      >
        <div class="w-[29%] p-[30px] project-attributes-container">
          <div class="key-deliverable">Key Deliverables</div>
        </div>
        <div class="flex-1 flex items-start mt-[30px]">
          <ul class="!pl-0">
            <div
              *ngFor="let goal of projectData?.projectGoalsData"
              class="flex"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="17"
                viewBox="0 0 10 10"
                fill="none"
              >
                <path
                  d="M4.61498 8.86234C4.58845 8.86234 4.56221 8.85685 4.53791 8.84621C4.51361 8.83558 4.49177 8.82003 4.47377 8.80055L0.666326 4.68199C0.640945 4.65454 0.624119 4.62027 0.617907 4.5834C0.611695 4.54653 0.616367 4.50865 0.631351 4.47439C0.646336 4.44013 0.670982 4.41099 0.702274 4.39052C0.733566 4.37005 0.770146 4.35915 0.807538 4.35915H2.64023C2.66775 4.35915 2.69494 4.36506 2.71998 4.37647C2.74502 4.38787 2.76732 4.40452 2.78538 4.42528L4.05785 5.88921C4.19536 5.59524 4.46158 5.10578 4.92873 4.50936C5.61935 3.62763 6.90392 2.33088 9.10169 1.16026C9.14417 1.13764 9.19359 1.13177 9.24018 1.14381C9.28678 1.15585 9.32717 1.18492 9.35338 1.22528C9.37958 1.26565 9.3897 1.31437 9.38174 1.36184C9.37377 1.4093 9.3483 1.45205 9.31035 1.48165C9.30196 1.4882 8.45458 2.15551 7.47935 3.3778C6.58181 4.50261 5.38869 6.34184 4.8016 8.71626C4.79128 8.75798 4.76729 8.79504 4.73346 8.82153C4.69963 8.84802 4.65789 8.86241 4.61492 8.86242L4.61498 8.86234Z"
                  fill="#1A4971"
                />
              </svg>
              <div class="flex">
                <span class="h-[22px] mr-[10px]">{{ goal?.name }}</span>
              </div>
            </div>
          </ul>
        </div>
      </div>

      <div class="flex justify-start gap-[50px] w-[100%] min-h-[228px]">
        <div class="w-[29%] p-[30px]">
          <div class="key-deliverable mb-[6px]">Budget</div>
          <div>
            <!-- TODO: -->
            <p class="project-attribute">Grade</p>
            <p class="project-attribute-value">{{ projectGradeData?.name }}</p>
          </div>
        </div>

        <div class="flex-1 flex flex-col items-start justify-center w-[100%]">
          <div class="w-[90%]">
            <div class="flex justify-between flex-col">
              <div class="flex justify-between items-center">
                <div>
                  <p class="milestone-header">Total Allocated</p>
                  <!-- TODO: this needs to be dynamic -->
                  <p class="milestone-value !mb-[10px]">
                    ${{ projectData?.projectBudgetData[0]?.amount }}
                  </p>
                </div>
                <div class="w-[515px] flex justify-start">
                  <div class="mt-[34px] mb-[34px]">
                    <p class="milestone-header">Amount In Words</p>
                    <p class="milestone-value !mb-[10px]">
                      <ng-container
                        *ngIf="projectData?.projectBudgetData[0]?.amount"
                      >
                        {{
                          numberToWords(
                            projectData?.projectBudgetData[0]?.amount
                          ) | titlecase
                        }}
                      </ng-container>
                    </p>
                  </div>
                </div>
              </div>

              <div
                *ngIf="
                  projectData?.projectBudgetData[0]?.risk_and_contengency_amount
                "
                class="flex justify-between items-center"
              >
                <div>
                  <p class="milestone-header">Risk & Contingency</p>
                  <p class="milestone-value !mb-[10px]">
                    ${{
                      projectData?.projectBudgetData[0]
                        ?.risk_and_contengency_amount
                    }}
                  </p>
                </div>
                <div class="w-[515px] flex justify-start">
                  <div class="mt-[34px] mb-[34px]">
                    <p class="milestone-header">Amount In Words</p>
                    <p class="milestone-value !mb-[10px]">
                      <ng-container
                        *ngIf="
                          projectData?.projectBudgetData[0]
                            ?.risk_and_contengency_amount
                        "
                      >
                        {{
                          numberToWords(
                            projectData?.projectBudgetData[0]
                              ?.risk_and_contengency_amount
                          ) | titlecase
                        }}
                      </ng-container>
                    </p>
                  </div>
                </div>
              </div>

              <div
                *ngIf="projectData?.projectBudgetData[0]?.gmp_amount"
                class="flex justify-between items-center"
              >
                <div>
                  <p class="milestone-header">GMP Amount</p>
                  <p class="milestone-value !mb-[10px]">
                    ${{ projectData?.projectBudgetData[0]?.gmp_amount }}
                  </p>
                </div>
                <div class="w-[515px] flex justify-start">
                  <div class="mt-[34px] mb-[34px]">
                    <p class="milestone-header">Amount In Words</p>
                    <p class="milestone-value !mb-[10px]">
                      {{
                        numberToWords(
                          projectData?.projectBudgetData[0]?.gmp_amount
                        ) | titlecase
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex justify-start gap-[50px] w-[100%] min-h-[228px]">
        <div class="w-[29%] p-[30px] project-attributes-container">
          <div class="key-deliverable mb-[6px]">Milestones</div>
          <div>
            <p class="project-attribute">Start Date</p>
            <p class="project-attribute-value">
              {{ projectData?.projectData?.start_date | date : "yyyy-MM-dd" }}
            </p>
          </div>
          <div>
            <p class="project-attribute">End Date</p>
            <p class="project-attribute-value !mb-[0px]">
              {{ projectData?.projectData?.end_date | date : "yyyy-MM-dd" }}
            </p>
          </div>
        </div>

        <div
          class="flex-1 flex flex-col items-start mt-[30px] justify-start w-[100%]"
        >
          <div class="w-[90%]">
            <div class="flex justify-between">
              <div>
                <p class="milestone-header">Description</p>
              </div>
              <div>
                <p class="milestone-header">From</p>
              </div>
              <div class="pr-[50px]">
                <p class="milestone-header">To</p>
              </div>
            </div>
          </div>

          <div
            *ngFor="let milestone of projectData?.projectMileStonesData"
            class="w-[90%]"
          >
            <div class="flex justify-between">
              <div>
                <p class="milestone-value !mb-[10px]">{{ milestone?.name }}</p>
              </div>
              <div>
                <p class="milestone-value !mb-[10px]">
                  {{ milestone?.start_date }}
                </p>
              </div>
              <div>
                <p class="milestone-value !mb-[10px] flex justify-start">
                  {{ milestone?.end_date }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex justify-start gap-[50px] w-[100%] min-h-[228px]">
        <div class="w-[29%] p-[30px]">
          <div class="key-deliverable">Stakeholders</div>
        </div>
        <div class="flex-1 flex flex-col items-start justify-start mt-[30px]">
          <div *ngFor="let stakeholder of projectData?.projectStakeHoldersData">
            <p class="project-attribute1">{{ stakeholder?.stake_holder }}</p>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="closeDialog()" class="mr-[30px]">Close</button>
    <button (click)="print()" class="print-button">Print</button>
  </mat-dialog-actions>
</ng-template>
